import { createSelector } from '@reduxjs/toolkit';
import { commentsSelector } from './reducer';
import { recommendationsSelector } from './reducer';

const recipesData = (state = {}) => state.recipe;

export const getSingleRecipe = createSelector(recipesData, (data) => data.recipe);

export const getLoading = createSelector(recipesData, (data) => data.ui.loading);

export const getComments = createSelector(recipesData, (data) =>
  commentsSelector.selectAll(data.comments),
);

export const getRecommendations = createSelector(recipesData, (data) =>
  recommendationsSelector.selectAll(data.recommendations),
);

export const getRecipeProduct = createSelector(recipesData, (data) => data.product);
